import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { IApi } from '../../common/ng-api/api.interface';
import { Shift } from '../../models/shift';
import { ShiftType } from '../../models/shift-type';
import { GenericApi } from '../../common/ng-api/generic-api';

@Injectable()
export class AmsShiftService {

  shifts: IApi<Shift>;
  shiftTypes: IApi<ShiftType>;

  constructor(private http: Http) {

    const baseApi = 'ams';

    this.shifts = new GenericApi<Shift>('shifts', http, baseApi);
    this.shiftTypes = new GenericApi<ShiftType>('shiftTypes', http, baseApi);

  }

  shiftColour = function (shiftType: ShiftType) {
    if (shiftType && shiftType.id) {
      return shiftType.color || '#000000'
    }

    return '#000000'
  }

}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/services/ams/ams-shift.service.ts